<template>
  <b-card>
    <b-tabs pills>
      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <feather-icon icon="UserIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Product Information</span>
        </template>
        <user-edit-tab-account
          :product-data="productModel"
          class="mt-2 pt-75"
        />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink } from "bootstrap-vue";
import { ref, onUnmounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import productStoreModule from "../productStoreModule";
import UserEditTabAccount from "./ProductEditTabAccount.vue";
import useUsersList from "../products-list/useProductsList.js";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    UserEditTabAccount,
  },
  setup() {
    const { productModel } = useUsersList();

    const USER_APP_STORE_MODULE_NAME = "product";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, productStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    store
      .dispatch("product/fetchProduct", { id: router.currentRoute.params.id })
      .then((response) => {
        console.log("getById", response);
        // map BindingData
      })
      .catch((error) => {
        if (error.response.status === 404) {
          console.log("err", error);
        }
      });

    return {
      productModel,
    };
  },
};
</script>

<style></style>
